import React, { MouseEvent } from 'react';
import { WithTranslation, useTranslation, withTranslation } from 'react-i18next';

import { Panel } from 'components/containers';
import { DataTableRow } from 'components/dataTable';
import DataTable from 'components/dataTable/dataTable';
import { TableFilters } from 'components/filters/table/tableFilters';
import { TableFiltersProps } from 'components/filters/table/types';
import { SearchInput } from 'components/inputs/search/search';

import { TablePagination } from 'types/pagination';
import { TableSorting } from 'types/sort';

import { ActionBar, Container } from './accountList.styles';
import { PartnerAccountCell } from './components/cells';
import { COLUMNS, LABELS } from './keys';
import { Filters, PartnerAccountDataRow } from './types';
import { makeFilterSections } from './utils';

interface AccountsListPageProps extends WithTranslation {
  partnerAccounts: PartnerAccountDataRow[];
  isLoading: boolean;
  pagination: TablePagination;
  onChangePage: (page: number) => void;
  onChangeRowsPerPage: (itemsPerPage: number) => void;
  onSort: (event: MouseEvent, property: string) => void;
  sorting: TableSorting;
  onSearch: (value: string) => void;
  search: string;
  filterProps: TableFiltersProps<Filters>;
  onRowClick: (row: DataTableRow) => void;
}

export const AccountsListPage = ({
  partnerAccounts,
  isLoading,
  pagination,
  onChangePage,
  onChangeRowsPerPage,
  onSort,
  sorting,
  onSearch,
  search,
  filterProps,
  onRowClick,
}: AccountsListPageProps) => {
  const { t } = useTranslation();
  const sections = makeFilterSections(filterProps.filterSettings);
  return (
    <Panel>
      <Container>
        <SearchInput search={search} onSearch={onSearch} placeholder={t(LABELS.SEARCH_PLACEHOLDER)} />
        <ActionBar>
          <TableFilters {...filterProps} sections={sections} />
        </ActionBar>
        <DataTable
          columns={COLUMNS}
          rows={partnerAccounts}
          CellComponent={PartnerAccountCell}
          pagination={pagination}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onSort={onSort}
          order={sorting.order}
          orderBy={sorting.orderBy}
          loading={isLoading}
          onRowClick={onRowClick}
        />
      </Container>
    </Panel>
  );
};

export const AccountsList = withTranslation()(AccountsListPage);
